export const USER_STORAGE = {
  token: 'asdl_user_token',
  refreshToken: 'asdl_user_refresh',
  user: 'asdl_user',
  pinDismissed: 'asdl_pin_dismissed',
} as const;

export const ADMIN_STORAGE = {
  token: 'asdl_admin_token',
  refreshToken: 'asdl_admin_refresh',
  admin: 'asdl_admin',
} as const;
